var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManageAssets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1H1.5C1.22386 1 1 1.21979 1 1.49091C1 1.76203 1.22386 1.98182 1.5 1.98182H14.5C14.7761 1.98182 15 1.76203 15 1.49091C15 1.21979 14.7761 1 14.5 1Z",
    fill: "#075AE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.9274H1.5C1.22386 4.9274 1 5.14719 1 5.41831C1 5.68943 1.22386 5.90922 1.5 5.90922H7.5C7.77614 5.90922 8 5.68943 8 5.41831C8 5.14719 7.77614 4.9274 7.5 4.9274Z",
    fill: "#075AE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38235 8.85469H1.5C1.22386 8.85469 1 9.07448 1 9.3456C1 9.61673 1.22386 9.83651 1.5 9.83651H7.38235C7.65849 9.83651 7.88235 9.61673 7.88235 9.3456C7.88235 9.07448 7.65849 8.85469 7.38235 8.85469Z",
    fill: "#075AE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.0547H10.5C10.2239 7.0547 10 7.27449 10 7.54562C10 7.81674 10.2239 8.03653 10.5 8.03653H14.5C14.7761 8.03653 15 7.81674 15 7.54562C15 7.27449 14.7761 7.0547 14.5 7.0547Z",
    fill: "#075AE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.50909V5.5818C13 5.31068 12.7761 5.09089 12.5 5.09089C12.2239 5.09089 12 5.31068 12 5.5818V9.50909C12 9.78021 12.2239 10 12.5 10C12.7761 10 13 9.78021 13 9.50909Z",
    fill: "#075AE9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAssets);
export default __webpack_public_path__ + "static/media/ManageAssets.f9f5692b.svg";
export { ForwardRef as ReactComponent };